module.exports = {
  favorites: require('./favorites'),
  tracks: require('./tracks')
}



/** WEBPACK FOOTER **
 ** ./client/index.js
 **/